import { config } from './config.js';
import { startPolling } from './fetchSnapshot.js';
import { renderApp } from './render.js';
import './styles.css';

const app = document.getElementById('app');
if (!app) {
  throw new Error('Dashboard root element #app is missing.');
}
const root = app as HTMLElement;

function update(
  snapshot: import('@amoeba/shared').Snapshot | null,
  status: import('./fetchSnapshot.js').SnapshotStatus,
): void {
  root.innerHTML = renderApp(snapshot, status);
}

// Render the initial loading state immediately.
update(null, 'loading');

// Start polling the brain's exported snapshot.
startPolling({
  url: config.snapshotUrl,
  intervalMs: config.pollIntervalMs,
  staleMs: config.staleThresholdMs,
  onUpdate: update,
});
